export function getCssProperty(propName: string): string {
  const el = document.body.classList.contains('high-contrast')
    ? document.body
    : document.querySelector(':root');

  const computedStyle = getComputedStyle(el);

  return computedStyle.getPropertyValue(propName);
}
